"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailgunEventType = void 0;
var MailgunEventType;
(function (MailgunEventType) {
    MailgunEventType["Accepted"] = "accepted";
    MailgunEventType["Rejected"] = "rejected";
    MailgunEventType["Delivered"] = "delivered";
    MailgunEventType["Failed"] = "failed";
    MailgunEventType["Opened"] = "opened";
    MailgunEventType["Clicked"] = "clicked";
    MailgunEventType["Unsubscribed"] = "unsubscribed";
    MailgunEventType["Complained"] = "complained";
    MailgunEventType["Stored"] = "stored";
})(MailgunEventType || (exports.MailgunEventType = MailgunEventType = {}));
//# sourceMappingURL=MailgunEventType.js.map